'use client';

import React from 'react';
import { RevshareTransaction } from '../types';
import { useTranslations } from '../../../../contexts/translation.context';
import Typography from '../../../../components/typography/Typography';

interface IncomeCellProps {
  transaction: RevshareTransaction;
}

const IncomeCell: React.FC<IncomeCellProps> = ({ transaction }) => {
  const { t } = useTranslations();

  if (transaction.compaign_type === 'cpl') {
    return null;
  }

  const amount = parseFloat(transaction.amount) || 0;
  const fee = parseFloat(transaction.fee) || 0;
  const commission = transaction.company?.commition || 0;

  const income = ((amount - fee) * (commission - 5)) / 100;

  return (
    <div className="flex items-center gap-1">
      <Typography variant="body3" className="!text-auth-muted">
        {t('partner.revshare.transactions.expected')}:
      </Typography>
      <Typography variant="label2" className="!text-[#11181C]">
        ${income.toFixed(2)}
      </Typography>
      <Typography variant="body3" className="!text-[#71717A]">
        ({commission - 5}%)
      </Typography>
    </div>
  );
};

export default IncomeCell;
